import { Row } from "@evergis/ui";

import {
  useCopyResourceDialog,
  useDeleteResourcesDialog,
  useEditResourceDialog,
  useExportDialog,
} from "hooks/useDialogs";
import { useCallback } from "react";

import { useLimitsExceededCheck } from "../../../../hooks/useLimitsExceededCheck";
import { useResourceType } from "../../../../hooks/useResourceType";

import { TableMenuValues } from "../../../Table/types";
import { useAccessDialog } from "../../hooks/useAccessDialog";

// eslint-disable-next-line max-lines-per-function
export const useTableActionsHandler = () => {
  const [resourceType] = useResourceType();
  const openCopyResourceDialog = useLimitsExceededCheck(useCopyResourceDialog());
  const openEditResourceDialog = useEditResourceDialog();
  const openDeleteResourcesDialog = useDeleteResourcesDialog();
  const openAccessDialog = useAccessDialog();
  const openExportDialog = useExportDialog();

  return useCallback(
    ({ data, id }: Row, selectedOptions) => {
      const { resourceAlias } = data;

      switch (selectedOptions[0].value) {
        case TableMenuValues.Settings:
          openEditResourceDialog([id as string, resourceType]);
          break;
        case TableMenuValues.Access:
          openAccessDialog(id as string, resourceType);
          break;
        case TableMenuValues.Copy:
          openCopyResourceDialog([id as string, resourceType]);
          break;
        case TableMenuValues.Delete:
          openDeleteResourcesDialog([id as string]);
          break;
        case TableMenuValues.Export:
          openExportDialog([id as string, resourceAlias as string, resourceType]);
          break;
        default:
          return null;
      }
    },
    [
      openEditResourceDialog,
      openAccessDialog,
      openCopyResourceDialog,
      openDeleteResourcesDialog,
      openExportDialog,
      resourceType,
    ],
  );
};
